namespace TabAurous.Stock.Repositories {
    export interface OwnStockKaratWise {
        id?: number;
        StockType?: string;
        KaratId?: number;
        KaratName?: string;
        CategoryName?: string;
        ProductName?: string;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondWeight?: number;
        StoneWeight?: number;
        MFAmount?: number;
    }
}
